import Icon from '../components/Icon.vue'

Icon.register({
  'user-md': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224 256c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128-57.3 128-128 128zM104 424c0-13.3 10.7-24 24-24s24 10.7 24 24-10.7 24-24 24-24-10.7-24-24zM320 288.6c71.2 3.5 128 61.8 128 133.8v44.8c0 24.7-20.1 44.8-44.8 44.8h-358.4c-24.7 0-44.8-20.1-44.8-44.8v-44.8c0-66.6 48.5-121.4 112.1-132.1v80.4c-23.1 6.9-40 28.1-40 53.4 0 30.9 25.1 56 56 56 30.9 0 56-25.1 56-56 0-25.3-16.9-46.5-40-53.4v-81.6c7.7 1 15.2 2.6 22.6 5.2 18 6.3 37.3 9.8 57.4 9.8 20.1 0 39.4-3.5 57.4-9.8 2.2-0.8 4.4-1.2 6.6-1.9v45.2c-36.5 7.5-64 39.8-64 78.4v43.8c0 8.1 5.9 14.8 13.8 15.9l31.2 4.2c4.3 0.8 8.5-2 9.4-6.3l3.1-15.7c0.8-4.3-2-8.5-6.3-9.4l-19.3-3.9v-26.7c0-67 96-64.7 96-1.9v28.5l-19.3 3.9c-4.4 0.8-7.2 5.1-6.3 9.4l3.1 15.7c0.9 4.4 5.1 7.2 9.4 6.3l32.2-6.4c7.5-1.5 12.9-8.1 12.9-15.7v-41.7c0-38.6-27.5-71-64-78.4v-49z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-md.js
// module id = 2068
// module chunks = 0